import React from "react";
import { Line } from 'react-chartjs-2';
import { Resizable } from 'react-resizable';
import 'chartjs-adapter-moment';
import { Contenedor, Main } from './ElementsDisplay';

export default function App({ info, variable }) {
  let options = {
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'hour',
          tooltipFormat: 'll HH:mm'
        }
      }
    },
    maintainAspectRatio: false
  };

  const adjustedEjex = info.map((fecha) => {
    const date = new Date(fecha.fechaCompleta);
    date.setHours(date.getHours() + 5);
    return date;
  });

  const valorVariable = info.map((valor) => {
    switch (variable) {
      case "Temperatura":
        return valor.temperature || valor.temperatura;
      case "Humedad":
        return valor.humidity || valor.humedad;
      case "Voltage":
        return valor.voltage;
      case "Potencia":
        return valor.potencia;
      case "Corriente":
        return valor.corriente;
      case "soilHumidity":
        return valor.soilHumidity;
      default:
        return null;
    }
  });

  const data = {
    labels: adjustedEjex,
    datasets: [
      {
        label: variable,
        data: valorVariable,
        fill: true,
        pointRadius: 1.8,
        backgroundColor: "rgba(111, 152, 234,0.2)",
        borderColor: "rgba(111, 152, 234,1)"
      }
    ]
  };

  options.plugins = {
    tooltip: {
      callbacks: {
        label: (context) => {
          const index = context.dataIndex;
          return `${variable}: ${valorVariable[index]}`;
        }
      }
    }
  };

  return (
    <>
      {info.length > 0 ? <>
        <Main>
          <Contenedor>
            <Resizable>
              <Line data={data} options={options} />
            </Resizable>
          </Contenedor>
        </Main>
      </> : <p>No hay Datos</p>}
    </>
  );
}
